"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectImportRowDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const ProjectImportServiceDTO_1 = require("./ProjectImportServiceDTO");
const IsNullable_1 = require("../../transformation/IsNullable");
class ProjectImportRowDTO {
}
exports.ProjectImportRowDTO = ProjectImportRowDTO;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], ProjectImportRowDTO.prototype, "position", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], ProjectImportRowDTO.prototype, "projectId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ProjectImportRowDTO.prototype, "projectName", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsUUID)(undefined, { each: true }),
    __metadata("design:type", Array)
], ProjectImportRowDTO.prototype, "additionalPms", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsNullable_1.IsNullable)(),
    __metadata("design:type", String)
], ProjectImportRowDTO.prototype, "projectSheet", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    __metadata("design:type", Boolean)
], ProjectImportRowDTO.prototype, "clientOffer", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    __metadata("design:type", Boolean)
], ProjectImportRowDTO.prototype, "wordbee", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    __metadata("design:type", Boolean)
], ProjectImportRowDTO.prototype, "tmConsolidated", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsNullable_1.IsNullable)(),
    __metadata("design:type", String)
], ProjectImportRowDTO.prototype, "comment", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsNullable_1.IsNullable)(),
    __metadata("design:type", String)
], ProjectImportRowDTO.prototype, "deliveryDate", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    __metadata("design:type", Boolean)
], ProjectImportRowDTO.prototype, "final", void 0);
__decorate([
    (0, IsNullable_1.IsNullable)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ProjectImportRowDTO.prototype, "invoiceNumber", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => ProjectImportServiceDTO_1.ProjectImportServiceDTO),
    (0, class_validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], ProjectImportRowDTO.prototype, "services", void 0);
